import { Button, Paper, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { AccordionChip } from '../../../common/components/AccordionChip';
import { t } from 'i18next';

type Props = {
  isLoading: boolean;
  icon: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  isConfigured: boolean;
  integrationPath: string;
  canUpdate: boolean;
};

export const IntegrationListItem = ({ isLoading, icon, title, subtitle, isConfigured, integrationPath, canUpdate }: Props) => {
  return (
    <Paper
      sx={{
        '&:hover': {
          transition: 'background-color 150ms',
          backgroundColor: 'backdrops.lightGrey',
        },
      }}
    >
      <Stack justifyContent={'space-between'} alignItems={'center'} direction={'row'} sx={{ p: 3 }} spacing={3}>
        <Stack gap={2}>
          <Stack direction="row" alignItems="center" gap={2} sx={{ minHeight: '2rem' }}>
            {icon}
            <Typography fontWeight="bold">{title}</Typography>
            {!isLoading && <AccordionChip isConfigured={isConfigured} />}
          </Stack>
          <Typography fontSize="0.875rem">{canUpdate ? subtitle : t('integrationList.noPermission')}</Typography>
        </Stack>
        {!isLoading && (
          <Button
            href={integrationPath}
            variant={isConfigured ? 'outlined' : 'contained'}
            disabled={!canUpdate}
            aria-label={
              isConfigured ? t('a11y.integrations.settingsLabel', { integration: title }) : t('a11y.integrations.configureLabel', { integration: title })
            }
          >
            {isConfigured ? t('settings') : t('configure')}
          </Button>
        )}
      </Stack>
    </Paper>
  );
};
